import React from 'react';
import { useHistory } from 'react-router-dom';
import { useGlobalStyles } from 'GlobalStyles';
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import { FPCard, FPCardContent } from 'UI/components/atoms/FPCard';
import { DuplicateCandidateAlert } from 'UI/components/molecules/DuplicateCandidateOverview';
import CandidateForm from 'UI/components/organisms/CandidateForm';
import { ContactRole } from 'UI/constants/entityTypes';
import { SeverityBySimilarity } from 'UI/constants/status';

export const MainCandidateSection = ({
  draftId,
  emailsValidation,
  hasSuperiorRole,
  updateDraft
}) => {
  const history = useHistory();
  const globalClasses = useGlobalStyles();

  const handleClickCreateFromContact = contactClicked => {
    const roleId = contactClicked?.role_id;

    if (!contactClicked?.id || roleId === null || roleId === undefined) return;

    const contactId = roleId === ContactRole.Name ? contactClicked?.id : null;
    const hiringId = roleId === ContactRole.HiringAuthority ? contactClicked?.id : null;

    const url = `${EntityRoutes.CandidateCreate}${contactId ? `?contactId=${contactId}` : ''}${
      hiringId ? `?hiringId=${hiringId}` : ''
    }`;
    history.push(url);
  };

  return (
    <FPCard className={globalClasses.newItemsSection}>
      <FPCardContent
        headerProps={{
          title: strings.candidates.creation.mainSection,
          subheader: strings.shared.fields.required,
          variant: 'section'
        }}
        variant="relaxed"
      >
        <When condition={emailsValidation.severity !== SeverityBySimilarity.None}>
          <DuplicateCandidateAlert
            emailValidation={emailsValidation}
            onClickCreateFromContact={handleClickCreateFromContact}
          />
        </When>

        <CandidateForm
          disabled={!hasSuperiorRole && emailsValidation.isRegistered}
          draftId={draftId}
          onValuesChanged={updateDraft}
          shouldSkipUnload
        />
      </FPCardContent>
    </FPCard>
  );
};
